import { Dispatcher } from 'src/utils/dispatcher';

import { PrayerPageEvents } from './types';

export const prayerDispatcher = new Dispatcher<PrayerPageEvents>();
